if (!window.teplepCardMobileSwipeInitialized) {
  window.teplepCardMobileSwipeInitialized = true;

  document.addEventListener('scroll', (event) => {
    const track = event.target;
    if (!(track instanceof Element) || !track.classList.contains('card__mobile-gallery-track')) return;

    const gallery = track.parentElement;
    const slides = track.querySelectorAll('.card__mobile-gallery-slide');
    if (!slides.length || !track.clientWidth) return;

    const activeIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    gallery.querySelector('[data-card-mobile-gallery-arrow="previous"]').disabled = activeIndex === 0;
    gallery.querySelector('[data-card-mobile-gallery-arrow="next"]').disabled = activeIndex === slides.length - 1;

    slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (!video) return;

      if (index === activeIndex) {
        video.play().catch(() => {});
      } else {
        video.pause();
        if (video.readyState > 0) video.currentTime = 0;
      }
    });
  }, true);

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-card-mobile-gallery-arrow]');
    if (!arrow) return;

    event.preventDefault();
    event.stopPropagation();

    const track = arrow.parentElement.querySelector('.card__mobile-gallery-track');
    const lastIndex = track.querySelectorAll('.card__mobile-gallery-slide').length - 1;
    const currentIndex = Math.round(track.scrollLeft / track.clientWidth);
    const direction = arrow.dataset.cardMobileGalleryArrow === 'next' ? 1 : -1;
    const nextIndex = Math.max(0, Math.min(lastIndex, currentIndex + direction));
    track.scrollTo({ left: nextIndex * track.clientWidth, behavior: 'smooth' });
  });
}
